<template>
  <div class="link-views white-bg">
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="dataList" :loading="loading">
        <template slot-scope="{ row }" slot="hasArticle">
          <span>{{row.IsList?'是':'否'}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a @click="showModalFn(row)">编辑</a>
        </template>
      </Table>
    </div>
    <!-- 编辑模态框 -->
    <Modal v-model="showModal" :mask-closable="false" title="编辑栏目">
      <Form ref="editItem" :model="editItem" :rules="ruleValidate" :label-width="80">
        <FormItem label="栏目名称" prop="ColumnName">
          <Input v-model="editItem.ColumnName"/>
        </FormItem>
        <FormItem label="是否显示文章列表" prop="IsList" :label-width="140">
          <i-switch v-model="editItem.IsList">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeApi from "../../../api/home-api.js";
export default {
  name: "column",
  data() {
    return {
      loading: true, //无数据显示加载中
      showModal: false, //显示编辑模态框
      dataList: [], //表格数据
      editItem: {}, //当前编辑项
      columns: [
        //设置表格参数
        {
          title: "栏目名称",
          key: "ColumnName",
          align: "center"
        },
        {
          title: "是否显示文章列表",
          slot: "hasArticle",
          align: "center"
        },
        {
          title: "可选操作",
          slot: "action",
          align: "center"
        }
      ],
      // 表单验证
      ruleValidate: {
        ColumnName: [
          { required: true, message: "栏目名称不能为空", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 获取栏目列表
    async getDataList() {
      this.dataList = await homeApi.GetSchoolColumnList();
      this.loading = false;
    },
    // 显示编辑条目
    showModalFn(row) {
      this.editItem = JSON.parse(JSON.stringify(row));
      this.showModal = true;
      // homeApi
      //   .GetSchoolColumnById({
      //     ColumnId: row.ColumnId
      //   })
      //   .then(res => {
      //     this.editItem = res;
      //     this.showModal = true;
      //   });
    },
    //确定编辑
    sureEdit(name) {
      var editItem = {
        ColumnId: this.editItem.ColumnId,
        ColumnName: this.editItem.ColumnName,
        IsList: this.editItem.IsList ? "1" : "0"
      };
      this.$refs[name].validate(valid => {
        if (valid) {
          homeApi.EditSchoolColumnById(editItem).then(res => {
            this.showModal = false;
            if (res.success) {
              this.getDataList();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>